module.exports = __webpack_public_path__ + "static/media/SujoyaDey@3x.7c61de93.png";